import { IFluidObject } from '@fluidframework/core-interfaces';
import { IContainerRuntime } from '@fluidframework/container-runtime-definitions';
import {
  IFluidDependencySynthesizer,
  FluidObjectSymbolProvider,
  FluidObjectKey,
  DependencyContainer
} from '@fluidframework/synthesize';
import { AsyncProvider } from '@fluidx/loop-types';

export class SharedContainerServiceFactory<O> {
  constructor(
    private readonly ctor: new (
      runtime: IContainerRuntime,
      providers: AsyncProvider<FluidObjectKey<O>>
    ) => IFluidObject,
    private readonly optionalProviders: FluidObjectSymbolProvider<O>
  ) {}
  public get IContainerServiceFactory() {
    return this;
  }

  // TODO: Replace runtime with dependency synthesizer
  public instantiateContainerService(runtime: IContainerRuntime) {
    const scope = runtime.scope;
    let dependencyContainer: IFluidDependencySynthesizer | undefined = scope.IFluidDependencySynthesizer;

    if (!dependencyContainer) {
      dependencyContainer = new DependencyContainer();
    }

    const providers = dependencyContainer.synthesize<O, {}>(this.optionalProviders, {});
    return new this.ctor(runtime, providers);
  }
}
